import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { LaddaModule } from 'angular2-ladda';
import { PaymentService } from '../services/payment.service';
import { SessionManager } from '../../common/helpers/session-manager';
import { AppLoggingService } from '../../common/services/AppLogging.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {
  progress: boolean | number = false;
  paymentStatus: string;

  constructor(private paymentService: PaymentService, private activatedRoute: ActivatedRoute,
     private sessionManager: SessionManager, private log: AppLoggingService, private router: Router) { }

  ngOnInit() {
  }

  getPaymentTerminal(): any {
    this.progress = 0;
    const customerDetails = this.sessionManager.getCurrentUser();
    const shopingCartItem = this.sessionManager.getShoppingCartData();
    const promoCode = this.sessionManager.getPromoCode();
    const sessionId = localStorage.getItem('sessionID');

    if (promoCode === 'medlemskap') {
      console.log('membership');
      this.paymentService.registerRecuringPayment(shopingCartItem.orderId, 'NOK', shopingCartItem.orderTotal,
      customerDetails.id, customerDetails.email, promoCode, sessionId).
      subscribe((response: any) => {
      }, error => {
      });
    }else {
      this.paymentService.registerPayment(shopingCartItem.orderId, 'NOK', shopingCartItem.orderTotal,
      customerDetails.id, customerDetails.email, promoCode, sessionId).
      subscribe((response: any) => {
      }, error => {
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-confirmation/payment-confirmation.component.ts